module.exports = __webpack_public_path__ + "components/home-header/static/header-4--large-f16391092877a5d3fc95385b6b60c79c.jpg";